import React from 'react';
import { ReactComponent as SwanWhiteImg } from '../images/swan-w.svg?react';
import LogoWithTrademark from '#app/components/LogoWithTrademark';
import blackswanLogo from '../images/blackswan-w.svg';
import * as S from './BlackSwanLogoLink.styles';

export default function BlackSwanLogoLink() {
  return (
    <S.Link
      href="https://blackswan.finance"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Black Swan Finance"
    >
      <S.IconWrap>
        <SwanWhiteImg />
      </S.IconWrap>
      <LogoWithTrademark
        contentOnly
        theme="light"
        brand="blackswan"
        title="чёрный лебедь"
        src={blackswanLogo}
      />
    </S.Link>
  );
}
